import { InjectOptions, Injector, ProviderToken } from '@angular/core';
import { PoprToastPackage } from './popr-toast.package';

/**
 * @internal
 *
 *  Mixin hierarchical injector for including {@link PoprToastPackage}s when creating a component.
 */
export class PoprToastInjector implements Injector {
  constructor(
    private poprToastPackage: PoprToastPackage,
    private parentInjector: Injector
  ) {
  }

  get(token: ProviderToken<any>, notFoundValue?: any, options?: (InjectOptions & {
    optional?: false;
  }) | InjectOptions): any {
    if (token === PoprToastPackage) return this.poprToastPackage;
    return this.parentInjector.get(token, notFoundValue, options);
  }
}
